import { ButtonVariant } from "@repo/ui/Buttons/button";
import { IconButton } from "@repo/ui/Buttons/iconButton";
import { IconShare2 } from "@tabler/icons-react";
import type { FC } from "react";

interface ShareFragmentIconButtonProps {
  onClick: () => void;
}

export const ShareFragmentIconButton: FC<ShareFragmentIconButtonProps> = ({
  onClick,
}) => {
  return (
    <div className="opacity-0 group-hover:opacity-100">
      <IconButton
        variant={ButtonVariant.Secondary}
        icon={<IconShare2 className="h-3 w-3" />}
        onClick={onClick}
      />
    </div>
  );
};
